import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { getToken } from "../utils/auth";
import {
  URL_S001,
  URL_S002,
  URL_S003,
  URL_S004,
  URL_S005,
  URL_S006,
  URL_S007,
  URL_S008,
  URL_S009,
  URL_S010,
} from "../utils/constants";
import Signout from "../assets/signout.png";
import Signin from "../assets/signin.jpg";

class Header extends Component {
  state = {};
  render() {
    const path = this.props.location.pathname;
    let getHeader = () => {
      switch (path.slice(0, 10)) {
        case URL_S001:
          return "Personal Timesheet List";
        case URL_S002:
          return "Personal Timesheet Entry";
        case URL_S003:
          return "Department Timesheet List";
        case URL_S004:
          return "Department Timesheet Entry";
        case URL_S005:
          return "Department Summary Approval List";
        case URL_S006:
          return "Department Timesheet Approval List";
        case URL_S007:
          return "Timesheet Approval Entry";
        case URL_S008:
          return "Department Summary Approval List - HR";
        case URL_S009:
          return "Department Timesheet Approval List - HR";
        case URL_S010:
          return "Timesheet Approval Entry - HR";
        case "/home/changePassword":
          return "Change Password";
        default:
          return "";
      }
    };
    let header = getHeader();
    return (
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <div className="nav-link" data-widget="pushmenu" role="button">
              <i className="fas fa-bars" />
            </div>
          </li>
        </ul>
        <span className="brand-text justify">{header}</span>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item d-none d-sm-inline-block">
            {getToken() ? (
              <Link
                to="/logout"
                className="nav-link justify-content-center align-items-center d-flex"
              >
                <i className="fas fa-sign-out-alt fa-lg" />
              </Link>
            ) : (
              <Link to="/login" className="nav-link">
                <img
                  src={Signin}
                  alt="Sign In"
                  className="brand-image ml-2"
                  width="30"
                  height="30"
                />
              </Link>
            )}
          </li>
        </ul>
      </nav>
    );
  }
}

export default withRouter(Header);
